<template>
  <div class="checkout-form use-case-form"  v-if="showUseCaseFields">
    <zm-form-item
      :label="__$t('billing.video_sdk.use_case')"
      size="xLarge"
      class="bpm-addr__required text-capitalize-form-item"
      ref="useCase"
      prop="useCase"
      for="use-case"
      aria-label="required"
    >
    <zm-select filterable v-model="form.useCase" :popper-append-to-body="true"
      :label="__$t('billing.video_sdk.use_case')">
        <zm-option
          v-for="item in useCaseList"
          :key="item.value"
          :label="getCaseTrans(__$t('billing.usecase.' + item.i18nKey),item)"
          :value="item.value"
        ></zm-option>
      </zm-select>
    </zm-form-item>
    <zm-form-item
      :label="__$t('billing.video_sdk.use_case_other')"
      size="xLarge"
      ref="otherUseCase"
      prop="otherUseCase"
      for="use-case-other"
      class="bpm-addr__required"
      aria-label="required"
      v-if="ifOtherSelected"
    >
      <zm-input v-model="form.otherUseCase"  id="use-case-other"/>
    </zm-form-item>
  </div>
</template>

<script>
import formMixins from './mixins/form-mixin.js';
import {translateMixins} from "../../plugins/i18n";
import {APP_NAMESPACE} from "../../store";
import {mapGetters} from "vuex";
export default {
  name: 'useCaseForm',
  mixins: [formMixins, translateMixins],
  props: {
    form: {
      type: Object,
    },
    isVideoSDKAccount: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapGetters(APP_NAMESPACE, ['useCaseList']),
    showUseCaseFields(){
      return this.isVideoSDKAccount
    },
    getOtherVal(){
      return this.useCaseList?.find(k=> k.i18nKey === 'other')?.value
    },
    ifOtherSelected(){
      return this.form.useCase === this.getOtherVal
    }
  },
  methods:{
    getCaseTrans(trans,item){
      if(trans.startsWith('billing.usecase')){
        return item.defaultText
      }else{
        return trans
      }
    }
  },
};
</script>
